module.exports = __webpack_public_path__ + "static/media/road_start.base64.69f89e04.svg";